// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/refresh-token-request-schema',
  type: 'object',
  required: ['accessToken', 'refreshToken'],
  properties: {
    accessToken: {
      type: 'string',
      minLength: 1,
    },
    refreshToken: {
      type: 'string',
      minLength: 1,
    },
  },
} as IJSONSchema;

export default schema;
